import React, { useContext, useEffect, useState } from 'react'

import Button from '@mui/material/Button'

import AuthContext from '@cpg-its/ads.auth.auth-context'
import LoggedOutModal from '../LoggedOutModal'

const UnAuthView = () => {
  const { loginWithRedirect } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (window.location.hash === '#logged_out') {
      setIsOpen(true)
    }
  }, [])

  return (
    <>
        <div className="text-center">
            <Button variant="contained" onClick={loginWithRedirect}>
                Log In
            </Button>
        </div>

      <LoggedOutModal open={isOpen} handleClose={() => setIsOpen(false)} />
    </>
  )
}

export default UnAuthView
